export default __webpack_public_path__ + "static/media/team.ded90abc.png";